export default __webpack_public_path__ + "beta-maps-guides-migrate-3d-model-1200-32e2a8b0e9e49b48751a1308907e4ed1.webp";